module.exports = __webpack_public_path__ + "public/img/why.cb96b848.png";